import { useState, type FormEvent } from 'react';
import { useAuth } from '../context/AuthContext';
import { Lock } from 'lucide-react';

export function LoginPage() {
  const { login } = useAuth();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    try {
      await login(password);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(18,181,229,0.25),_transparent_60%)]">
      <div className="glass-panel w-full max-w-md rounded-3xl p-10 text-white">
        <Lock className="h-12 w-12 text-brand" />
        <h1 className="mt-6 text-3xl font-semibold">NetDrive</h1>
        <p className="text-sm text-white/60">输入主密码以继续</p>
        <form className="mt-8 space-y-4" onSubmit={handleSubmit}>
          <label className="text-sm text-white/70">密码</label>
          <input
            type="password"
            value={password}
            onChange={(event) => setPassword(event.target.value)}
            className="w-full rounded-2xl border border-white/10 bg-black/20 px-4 py-3 outline-none focus:border-brand"
          />
          <button className="w-full rounded-2xl bg-gradient-to-r from-brand to-accent py-3 text-base font-semibold" disabled={loading}>
            {loading ? '验证中…' : '进入我的网盘'}
          </button>
        </form>
      </div>
    </div>
  );
}
